import { Box, Typography } from "@mui/material";

export const TagChip = ({
	label,
	count,
	color,
	selected = false,
	onClick,
}: {
	label: string;
	count?: number;
	color: string;
	selected?: boolean;
	onClick?: () => void;
}) => {
	return (
		<Box
			sx={{
				backgroundColor: selected ? color : "#fff",
				color: selected ? "#fff" : color,
				border: `2px solid ${color}`,
				borderRadius: "20px",
				fontSize: "14px",
				fontWeight: "500",
				minWidth: "fit-content",
				whiteSpace: "nowrap",
				paddingX: "8px",
				paddingY: "4px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				gap: "6px",
				cursor: "pointer",
				transition: "all 0.2s ease",
				"&:hover": {
					backgroundColor: color,
					color: "#fff",
					transform: "translateY(-1px)",
					boxShadow: `0 4px 8px ${color}40`,
				},
			}}
			onClick={onClick}
		>
			<Typography
				sx={{
					fontSize: "14px",
					fontWeight: selected ? "600" : "500",
					lineHeight: 1,
				}}
			>
				{label}
			</Typography>
			{count !== undefined && count > 0 && (
				<Box
					sx={{
						backgroundColor: selected ? "#fff" : color,
						color: selected ? color : "#fff",
						borderRadius: "50%",
						minWidth: "24px",
						height: "24px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						fontWeight: "700",
						fontSize: "14px",
					}}
				>
					{count}
				</Box>
			)}
		</Box>
	);
};


